module.exports = __webpack_public_path__ + "static/media/projects.a1e62018.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/information-center/projects.svg
// module id = 1209
// module chunks = 0